<template>
  <div class="book_notes">
    <div class="notes_header">
      <div class="header_title">书摘秀</div>
      <div class="shuffle_btn" :class="{ shuffling: isShuffling }" @click="shuffle">
        <span class="shuffle_icon">&#8635;</span>
        <span class="shuffle_text">重新洗牌</span>
      </div>
    </div>

    <div class="notes_body" :class="{ shuffling: isShuffling }">
      <template v-if="!isMobile">
        <div class="notes_wall">
          <div
            class="wall_item"
            v-for="(item, index) in digestList"
            :key="item.id || index"
            :style="{ animationDelay: (index * 0.03) + 's' }"
          >
            <note-card :item="item" @click="openDetail(item)" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="mobile_wall">
          <div
            class="wall_item"
            v-for="(item, index) in digestList"
            :key="item.id || index"
            :style="{ animationDelay: (index * 0.03) + 's' }"
          >
            <note-card :item="item" @click="openDetail(item)" />
          </div>
        </div>
        <div class="mobile_shuffle_bar">
          <div class="shuffle_btn mobile_shuffle" :class="{ shuffling: isShuffling }" @click="shuffle">
            <span class="shuffle_icon">&#8635;</span>
            <span class="shuffle_text">重新洗牌</span>
          </div>
        </div>
      </template>
    </div>

    <detail-panel :visible.sync="showDetail" :item="detailItem" />
  </div>
</template>

<script>
import noteCard from './component/noteCard.vue'
import detailPanel from './component/detailPanel.vue'
import { randomDigest } from '@/vue_api/bookNotes.js'

export default {
  name: 'bookNotes',
  components: {
    noteCard,
    detailPanel
  },
  data() {
    return {
      digestList: [],
      showDetail: false,
      detailItem: {},
      isShuffling: false,
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.fetchData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 500
    },
    async fetchData() {
      try {
        const res = await randomDigest()
        this.digestList = res && res.data && res.data.status ? res.data.digestList : []
      } catch (e) {
        this.digestList = []
      }
    },
    openDetail(item) {
      this.detailItem = item
      this.showDetail = true
    },
    shuffle() {
      if (this.isShuffling) return
      this.isShuffling = true
      setTimeout(() => {
        const shuffled = [...this.digestList]
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
        }
        this.digestList = shuffled
        this.$nextTick(() => {
          this.isShuffling = false
        })
      }, 600)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>